// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IActionButtonV2Schema } from '../action_button_v2/ActionButtonV2Schema';
import type { IActionButtonV3Schema } from '../action_button_v3/ActionButtonV3Schema';
import type { IMessageAssumptionsSchema } from '../check_message/MessageAssumptionsSchema';
import type { IBubbleSchema } from '../bubble/BubbleSchema';
import type { IMessageListFilesSchema } from '../file/MessageListFilesSchema';
import type { IOfferForClientSchema } from '../for_client/OfferForClientSchema';

export interface IMessageListItemV2Schema {
  /** Пользователь может выбрать из предлагаемых действий/ответов в зависимости от того что написано в сообщение. **/
  actionButtons?: IActionButtonV2Schema[];
  /**
   *
   *     Пользователь может выбрать из предлагаемых действий/ответов в зависимости от того что написано в сообщение;
   *     Формат кнопок v3
   *
   */
  actionButtonsV3?: IActionButtonV3Schema[];
  /** Информация о различных предположениях/подозрениях по данному сообщению **/
  assumptions?: IMessageAssumptionsSchema;
  /** Дополнительные сообщения для пользователя, которые видит только он **/
  bubbles?: IBubbleSchema[];
  /** Идентификатор чата **/
  chatId: string;
  /** Уникальный id коммуникации **/
  communicationId?: string;
  /**
   *
   *     Момент создания сообщения в формате ISO-8601, пример: 2022-08-01T01:34:03.123456+00:00.
   *
   */
  created: string;
  /** Файлы прикреплённые к сообщению **/
  files?: IMessageListFilesSchema;
  /** Текст html **/
  htmlText?: string;
  /** Идентификатор сообщения **/
  messageId: string;
  /** Объявления прикреплённые к сообщению **/
  offers: IOfferForClientSchema[];
  /** Версия строки сообщения **/
  rowVersion: number;
  /**
   * Версия строки сообщения, может включать в себя row_version сообщения,
   *     а так же версии других сущностей, например row_version объявления
   */
  rowVersionV2: string;
  /** Статус сообщения **/
  status: EStatus;
  /** Текст сообщения **/
  text?: string;
  /** Тип сообщения **/
  type: EType;
  /**
   *
   *     UUID, который приходит с фронта, чтобы при ответе по сокету фронт смог понять к какому
   *     сообщению относится ответ. Важно в случае отправки нескольких сообщений подряд.
   *
   */
  uid?: string;
  /** Идентификатор автора сообщения (realty_user_id) **/
  userId: number;
}

export enum EStatus {
  /** Удалено **/
  'Deleted' = 'deleted',
  /** Доставлено до сервера **/
  'DeliveredToServer' = 'deliveredToServer',
  /** Прочитано получателем **/
  'ReadByRecipient' = 'readByRecipient',
}
export enum EType {
  /** Данные о входящем лиде **/
  'LeadInfo' = 'leadInfo',
  /** Сообщение-объявление **/
  'Offer' = 'offer',
  /**
   *
   *     Системное сообщение. Которое, к примеру, может возникать тогда,
   *     когда пользователь присоединился к чату или вышел из него.
   *
   */
  'SystemInfo' = 'systemInfo',
  /** Текстовое сообщение **/
  'Text' = 'text',
  /** Сообщение с прикрепленными файлами. Текст сообщения может отсутствовать. **/
  'TextAndFiles' = 'textAndFiles',
  /**
   *
   *     Используется только в случае когда сообщение представлено для чатов 1.0,
   *     и при этом у сообщения есть несколько вариантов ответов/действий
   *     или есть хоть один вариант ответа с типом ActionButtonV2Type.deeplink
   *
   */
  'TextWithActions' = 'textWithActions',
}
